<template>
  <span class="bouton-dictee" :class="{ 'bouton-dictee--flottant': flottant }">
    <button type="button" class="dictation-button" :class="{ 'dictation-button--active': actif, 'dictation-button--compact': compact }" :aria-pressed="actif ? 'true' : 'false'"
      :aria-label="actif ? 'Arrêter la dictée vocale' : 'Démarrer la dictée vocale'" :title="actif ? 'Arrêter la dictée vocale' : 'Démarrer la dictée vocale'"
      @mousedown.prevent @click="basculer">
      <i class="ic-microphone" aria-hidden="true"></i>
      {{ compact ? (actif ? 'Arrêter' : 'Dicter') : (actif ? 'Arrêter la dictée' : 'Démarrer la dictée vocale') }}
    </button>
    <span v-if="actif && apercu" class="bd-apercu" aria-live="polite">{{ apercu }}</span>
    <span v-if="message" class="bd-message" role="status">{{ message }}</span>
  </span>
</template>

<script>
import { creerDictee, insererDictee, champEditable, champsAvecBouton } from '@/utils/dictee'

// Bouton « Démarrer la dictée vocale » (04/10/2026), le même que la synthèse, pour n'importe quel champ texte :
// pour = id du champ (zone de texte, champ texte ou éditeur riche) ; ou cible = fonction qui renvoie l'élément.
export default {
  name: 'BoutonDictee',
  props: {
    pour: { type: String, default: '' },
    cible: { type: Function, default: null },
    flottant: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
  },
  data() {
    return { actif: false, apercu: '', message: '', dictee: null, champ: null }
  },
  watch: {
    pour: { immediate: true, handler(nouveau, ancien) {
      if (ancien) champsAvecBouton.delete(ancien)
      if (nouveau && !this.flottant) champsAvecBouton.add(nouveau)
    } },
  },
  beforeDestroy() {
    if (this.pour && !this.flottant) champsAvecBouton.delete(this.pour)
    if (this.dictee) this.dictee.arreter()
  },
  methods: {
    element() {
      const brut = this.cible ? this.cible() : (this.pour ? document.getElementById(this.pour) : null)
      return champEditable(brut)
    },
    arreter() {
      if (this.dictee) this.dictee.arreter()
    },
    async basculer() {
      if (this.actif) { this.arreter(); return }
      const champ = this.element()
      if (!champ) { this.message = 'Cliquez d’abord dans le champ à dicter.'; return }
      this.champ = champ
      try { champ.focus() } catch (_) { /* champ non focalisable */ }
      if (!this.dictee) {
        this.dictee = creerDictee({
          surFinal: texte => {
            // Le champ a disparu (fenêtre fermée) : la dictée s'arrête.
            if (!this.champ || !document.body.contains(this.champ)) { this.arreter(); return }
            insererDictee(this.champ, texte)
          },
          surApercu: texte => { this.apercu = texte },
          surEtat: actif => { this.actif = actif; this.$emit('etat', actif) },
          surMessage: message => { this.message = message },
        })
      }
      await this.dictee.demarrer()
    },
  },
}
</script>

<style scoped>
.bouton-dictee { display: inline-flex; flex-wrap: wrap; align-items: center; gap: 6px 10px; vertical-align: middle; }
.dictation-button { display: inline-flex; align-items: center; justify-content: center; gap: 9px; min-height: 38px; padding: 7px 14px; border: 1px solid #c9d7fc;
  border-radius: 9px; background: #fff; color: var(--ui-accent, #3369e8); font-weight: 600; font-size: 14px; line-height: 1.25; white-space: nowrap; cursor: pointer; }
.dictation-button:hover { background: #edf3ff; border-color: #5d84f6; }
.dictation-button:focus-visible { outline: 3px solid #8caaf5; outline-offset: 2px; }
.dictation-button .ic-microphone { display: inline-block; width: 18px; height: 18px; min-width: 18px; flex: 0 0 18px; }
.dictation-button--active { border-color: #e9a8a8; background: #fff0f0; color: #9b2626; }
.dictation-button--compact { min-height: 30px; padding: 4px 9px; gap: 5px; font-size: 12px; }
.dictation-button--compact .ic-microphone { width: 15px; height: 15px; min-width: 15px; }
.bd-apercu { max-width: 420px; overflow: hidden; color: var(--ui-text-muted, #526074); font-size: 13px; font-style: italic; text-overflow: ellipsis; white-space: nowrap; }
.bd-message { color: #8a4b08; font-size: 13px; }
.bouton-dictee--flottant .dictation-button { min-height: 34px; padding: 5px 12px; font-size: 13px; box-shadow: 0 4px 14px rgba(23, 32, 51, .16); }
</style>
